


































































































































import { defineComponent, onMounted, reactive, ref } from '@vue/composition-api';
import SinglePage from '@components/SinglePage';
import request from '@/utils/request';
import { dialogObj, dialogSubmit, tipsDialog, closeDialog, dialogConfirm } from '@/useable/dialog';
import { userInfor as userInfoRef } from '@/useable/login';
import svgCom from '@components/Svg/index';
const userInfor = userInfoRef.value;

export default defineComponent({
  name: 'Role',
  components: { SinglePage, svgCom },
  setup(props, {root}) {
    const pageLoading = ref(true);
    const tableLoading = ref(true);
    const ruleForm = ref(null);
    const isCore = ref(userInfor.isCore);
    // 搜索表单配置
    const searchFormOptions = reactive({
      form: {
        name: '',
        cellPhone: '',
        roleName: '',
        roleCode: '',
      },
      formColumn: [
        {
          name: 'name',
          type: 'input',
          label: '员工姓名：',
          disabled: false,
          placeholder: '输入员工姓名',
        },
        {
          name: 'cellPhone',
          type: 'input',
          label: '手机号：',
          placeholder: '输入手机号',
        },
        {
          name: 'roleCode',
          type: 'select',
          label: '角色：',
          placeholder: '',
          options: [
            {
              value: '',
              name: '全部',
            },
          ],
        },
      ]
    });

    // 表格数据初始化
    const tableData = ref([]);
    const columns = ref([
      {
        label: '姓名',
        key: 'name',
      },
      {
        label: '角色',
        key: 'roleName',
        width: 120
      },
      {
        label: '手机号码',
        key: 'cellPhone',
        width: 140
      },
      {
        label: '邮箱',
        key: 'workEmail',
        width: 240
      },
      {
        label: '邀请时间',
        key: 'inviteTime',
        width: 110
      },
      {
        label: '注册时间',
        key: 'registerTime',
        width: 110
      },
    ]);

    // 分页数据
    const paginationOptions = reactive({
      size: 10,
      current: 1,
      total: 0,
    });

    const userRole = ref(['sys_user_role']) as any;
    const roleCodeList: any = ref([]);

    // 获取表格数据方法
    const getTableData = async (queryParams) => {
      tableLoading.value = true;
      const res = await request('role', 'getSysUserRole', queryParams);
      if (res?.code === 2000) {
        tableData.value = res.data.records;
        paginationOptions.total = res.data.total;
        paginationOptions.current = res.data.current;
        const temp = res.data.records.filter(
          item => item.isOperation === 0
        );
        if (temp.length > 0) {
          userRole.value =temp;
          tableOptions.showEditColumn = userRole.value[0].roleCode === 'supplier_administrator' || userRole.value[0].roleCode === 'core_administrator';
        }
        tableLoading.value = false;
      }
    };

    const listCallback = async () => {
      await getTableData(Object.assign(searchFormOptions.form, {size: paginationOptions.size, current: paginationOptions.current}));
    };

    // 数据表格配置
    const tableOptions = reactive({
      tableData,
      columns,
      showSelection: false,
      showEditColumn: true,
      btnsWidth: '160',
      tableLoading,
      getTableData,
      handleSelectionChange: () => {}
    });

    // 获取用户信息
    const getUserData = async () => {
      const res = await request('role', 'getUserRoleCode', {});
      if (res.code === 2000) {
        if (isCore.value) {
          roleCodeList.value = res.data;
        } else {
          roleCodeList.value = res.data.filter(i=>i.roleName==='普通操作人');
        }
        searchFormOptions.formColumn[2].options = searchFormOptions.formColumn[2].options?.concat(
          res.data.map(item => ({
            value: item.roleCode,
            name: item.roleName
          }))
        );
        await listCallback();
      }
      pageLoading.value = false;
    };

    const defaultFormData = reactive({
      name: '',
      cellPhone: '',
      workEmail: '',
      roleName: '',
      roleCode: ''
    });
    const dialogFormData = reactive({
      name: '',
      cellPhone: '',
      workEmail: '',
      roleName: '',
      roleCode: '',
      type: 'invitationReq',
      loginName: userInfor.name,
    });

    // 手机号校验
    const validateNum = (rule, value, callback) => {
      const phone =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!phone.test(value) && value) {
        callback(new Error('手机号格式不正确'));
      } else {
        callback();
      }
    };

    const rules = {
      name: [
        { required: true, message: '请输入员工姓名', trigger: 'blur' },
      ],
      roleCode: [
        { required: true, message: '请选择角色', trigger: 'change' },
      ],
      cellPhone: [
        { required: true, message: '请输入手机号', trigger: 'blur' },
        { validator: validateNum, trigger: ['blur', 'change'] },
      ],
      workEmail: [
        { required: true, message: '请输入邮箱', trigger: 'blur' },
        {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: ['blur', 'change'],
        },
      ]
    };

    // 增删改
    const onAdd = () => {
      dialogObj.type = 'add';
      dialogObj.title = '新增人员';
      dialogObj.btnText = '发送邀请邮件';
      Object.assign(dialogFormData, defaultFormData);
      dialogObj.state = true;
    };
    const onEdit = (data) => {
      console.log(data);
      dialogObj.type = 'edit';
      dialogObj.title = '编辑人员';
      dialogObj.btnText = '保存';
      Object.assign(dialogFormData, data);
      dialogObj.state = true;
    };
    const onDelete = (data) => {
      dialogObj.type = 'delete';
      Object.assign(dialogFormData, data);
      tipsDialog.text = '确定删除该角色？';
      tipsDialog.icon = 'el-icon-warning';
      tipsDialog.btns = ['cancel', 'delete'];
      tipsDialog.showDialog = true;
    };

    onMounted(() => {
      getUserData();
    });

    return {
      pageLoading,
      searchFormOptions,
      tableOptions,
      paginationOptions,
      listCallback,
      // 页面数据&方法
      userRole,
      roleCodeList,
      onAdd,
      onEdit,
      onDelete,
      dialogObj,
      closeDialog,
      dialogSubmit,
      dialogConfirm,
      defaultFormData,
      dialogFormData,
      tipsDialog,
      rules,
      ruleForm,
      isCore
    };
  }
});
